"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var public_api_1 = require("@l2p/public-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var InputText_1 = __importDefault(require("../../InputText"));
var BonusInfo_1 = __importDefault(require("../Modals/BonusInfo"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Bonuses = function (_a) {
    var _b, _c, _d;
    var _e = _a.promocode, promocode = _e === void 0 ? '' : _e, bonuses = _a.bonuses, bonusesData = _a.bonusesData, isLoading = _a.isLoading, isValidating = _a.isValidating, setPromocode = _a.setPromocode, tab = _a.tab, setTab = _a.setTab, selectedBonus = _a.selectedBonus, toggleCloseBonus = _a.toggleCloseBonus;
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var breakpoint = (0, apps_shared_1.useBreakpoint)();
    var _f = (0, react_1.useState)(promocode), promocodeValue = _f[0], setPromocodeValue = _f[1];
    var _g = (0, react_1.useState)(false), promocodeInvalid = _g[0], setPromocodeInvalid = _g[1];
    var _h = (0, react_1.useState)(false), promocodeNotApplied = _h[0], setPromocodeNotApplied = _h[1];
    var promocodeRef = (0, react_1.useRef)(null);
    var _j = (0, react_1.useState)(false), isOpenBonusInfo = _j[0], setIsOpenBonusInfo = _j[1];
    var _k = (0, react_1.useState)(), bonusInfo = _k[0], setBonusInfo = _k[1];
    var _l = (0, react_1.useState)(false), isOpenDropdown = _l[0], setIsOpenDropdown = _l[1];
    var t = (0, next_intl_1.useTranslations)('translation');
    var formState = (0, react_final_form_1.useFormState)();
    var form = (0, react_final_form_1.useForm)();
    var validatePromocode = function () {
        setPromocode(promocodeValue || undefined);
    };
    (0, react_1.useEffect)(function () {
        if (promocodeValue &&
            !(isLoading || isValidating) &&
            !(bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.promoId)) {
            setPromocodeInvalid(true);
        }
        else {
            setPromocodeInvalid(false);
        }
    }, [promocodeValue, isLoading, isValidating, bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.promoId]);
    (0, react_1.useEffect)(function () {
        if (promocodeValue &&
            !(isLoading || isValidating) &&
            (bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.promoId) &&
            !(bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.bonuses.find(function (b) { return b.type === public_api_1.BonusType.Promo; }))) {
            setPromocodeNotApplied(true);
        }
        else {
            setPromocodeNotApplied(false);
        }
    }, [
        promocodeValue,
        isLoading,
        isValidating,
        bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.bonuses,
        bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.promoId,
    ]);
    (0, react_1.useEffect)(function () {
        if (promocodeValue !== promocode) {
            setPromocodeInvalid(false);
        }
    }, [promocodeValue, promocode]);
    var minDepositData = (_b = selectedBonus === null || selectedBonus === void 0 ? void 0 : selectedBonus.conditions) === null || _b === void 0 ? void 0 : _b.find(function (c) { return c.type === public_api_1.BonusConditionType.MinDepositAmount; });
    var minDeposit = (_c = minDepositData === null || minDepositData === void 0 ? void 0 : minDepositData.minDeposit) === null || _c === void 0 ? void 0 : _c.find(function (d) { return d.currency === currentCurrency; });
    var toggleBonusAccept = (0, react_1.useCallback)(function (bonus) {
        form.change('bonusId', bonus === null || bonus === void 0 ? void 0 : bonus.id);
        if ((bonus === null || bonus === void 0 ? void 0 : bonus.type) === 'PROMO') {
            form.change('promoId', bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.promoId);
        }
        else {
            form.change('promoId', undefined);
        }
    }, [form, bonusesData]);
    var minDepositAmount = minDeposit === null || minDeposit === void 0 ? void 0 : minDeposit.amount;
    if (isLoading)
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.spinnerContainer },
            react_1.default.createElement(ui_components_1.LoadingSpinner, { size: "sm" })));
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.tabs },
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.tab, " ").concat(tab === 'bonus' ? styles_module_scss_1.default.activeTab : '', " "), onClick: function () { return setTab('bonus'); } },
                react_1.default.createElement("span", null, t('bonus'))),
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.tab, " ").concat(tab === 'promocode' ? styles_module_scss_1.default.activeTab : '', " "), onClick: function () { return setTab('promocode'); } },
                react_1.default.createElement("span", null, t('promocode')))),
        tab === 'promocode' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.promocode },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.inputWrapper },
                react_1.default.createElement(InputText_1.default, { innerRef: promocodeRef, name: promocode || '', placeholder: "", value: promocodeValue, onChange: function (e) { return setPromocodeValue(e.target.value); }, errorTextCentered: true, helpertext: promocodeInvalid
                        ? { status: 'error', text: t('inputPromocodeInvalid') }
                        : promocodeNotApplied
                            ? { status: 'error', text: t('inputPromocodeNotApplied') }
                            : undefined }),
                !promocodeValue && (react_1.default.createElement("span", { onClick: function (e) {
                        var _a;
                        (_a = promocodeRef === null || promocodeRef === void 0 ? void 0 : promocodeRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    }, className: styles_module_scss_1.default.placeholder }, t('inputPromocodePlaceholder')))),
            Object.keys(breakpoint).length > 0 &&
                // breakpoint.mobile &&
                promocodeValue && (react_1.default.createElement("div", { className: styles_module_scss_1.default.mobileButton },
                react_1.default.createElement(ui_components_1.FixedButton, { type: "button", color: "gradient", text: "upper", loading: isValidating || isLoading, height: "27px", maxWidth: "100%", onClick: validatePromocode }, t('confirm')))))),
        tab === 'bonus' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.bonuses },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusesInner },
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.bonusesDropdown, " ").concat(isOpenDropdown ? styles_module_scss_1.default.bonusesDropdownOpen : '') },
                    react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.bonusesDropdownLabel), onClick: function () { return setIsOpenDropdown(!isOpenDropdown); } },
                        react_1.default.createElement("span", { className: "".concat(selectedBonus ? styles_module_scss_1.default.bonusesDropdownLabelSelected : '') }, selectedBonus
                            ? ((_d = selectedBonus === null || selectedBonus === void 0 ? void 0 : selectedBonus.descriptions) === null || _d === void 0 ? void 0 : _d.shortTitle) ||
                                (selectedBonus === null || selectedBonus === void 0 ? void 0 : selectedBonus.title)
                            : t('chooseAvailableBonus')),
                        react_1.default.createElement(image_1.default, { alt: "arrow", src: isOpenDropdown
                                ? '/img/icons/dropdown-arrow-round-gold.svg'
                                : '/img/icons/dropdown-arrow-round.svg', width: 12, height: 12 })),
                    isOpenDropdown && (react_1.default.createElement("div", { className: styles_module_scss_1.default.blur, onClick: function () { return setIsOpenDropdown(false); } })),
                    isOpenDropdown && (react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusesDropdownList }, bonuses.length ? (bonuses === null || bonuses === void 0 ? void 0 : bonuses.map(function (b) {
                        var _a;
                        return (react_1.default.createElement("div", { key: b.id, className: styles_module_scss_1.default.bonusesDropdownItem, onClick: function () {
                                toggleBonusAccept(b);
                                setIsOpenDropdown(false);
                            } },
                            react_1.default.createElement("span", null, ((_a = b.descriptions) === null || _a === void 0 ? void 0 : _a.shortTitle) || (b === null || b === void 0 ? void 0 : b.title))));
                    })) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.dontHaveBonus }, t('dontHaveBonus')))))),
                isOpenBonusInfo && (react_1.default.createElement(BonusInfo_1.default, { bonus: bonusInfo, onClose: function (e) {
                        e.stopPropagation();
                        toggleBonusAccept(bonusInfo);
                        setIsOpenBonusInfo(false);
                    }, onCancel: function (e) {
                        e.stopPropagation();
                        setIsOpenBonusInfo(false);
                    } }))))),
        selectedBonus && (react_1.default.createElement("div", { className: styles_module_scss_1.default.selectedBonusWrap },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.selectedBonus },
                react_1.default.createElement("span", null,
                    react_1.default.createElement("span", null, selectedBonus === null || selectedBonus === void 0 ? void 0 : selectedBonus.title),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.close, onClick: toggleCloseBonus },
                        react_1.default.createElement("img", { src: "/img/icons/close.svg", alt: "icon" }))),
                minDepositAmount && (react_1.default.createElement("div", { className: styles_module_scss_1.default.selectedBonusInfo },
                    react_1.default.createElement("div", null,
                        t('minDepositAmount'),
                        ": ",
                        (0, apps_shared_1.getCurrencySymbol)(currentCurrency),
                        minDepositAmount),
                    react_1.default.createElement("div", null,
                        "Wager:",
                        ' ',
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.wager },
                            "x", selectedBonus === null || selectedBonus === void 0 ? void 0 :
                            selectedBonus.wageringMultiplier)))))))));
};
exports.default = Bonuses;
